"use strict";

exports.__esModule = true;
exports.UnwrappedDropdown = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _popper = _interopRequireDefault(require("popper.js"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _Dropdown = _interopRequireDefault(require("../Icons/Dropdown"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _DropdownItem = _interopRequireDefault(require("./DropdownItem"));

exports.DropdownItem = _DropdownItem.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: ", ";\n\tbackground: #fff;\n\tflex: 0 1 150px;\n\tflex-direction: column;\n\tposition: absolute;\n\tbox-shadow: ", ";\n\tborder-radius: ", ";\n\toverflow: hidden;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont: inherit;\n\tpadding-right: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\theight: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: 10px;\n\twidth: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Container = _styledComponents.default.div(_templateObject());

Container.displayName = 'Container';
var DropdownIcon = (0, _styledComponents.default)(_Dropdown.default)(_templateObject2());

var FlexContainer = _styledComponents.default.div(_templateObject3());

var TitleContainer = _styledComponents.default.span(_templateObject4(), _spacing.default.s1);

var ItemsList = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.visible ? 'flex' : 'none';
}, _vars.default.boxShadow, _vars.default.borderRadius);

ItemsList.displayName = 'ItemsList';
FlexContainer.displayName = 'FlexContainer';
DropdownIcon.displayName = 'DropdownIcon';
TitleContainer.displayName = 'TitleContainer';

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Dropdown, _React$Component);

  function Dropdown(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isOpen: false
    };
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    _this.button = _react.default.createRef();
    _this.menu = _react.default.createRef();
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var placement = this.props.placement;
    this.popper = new _popper.default(this.button.current, this.menu.current, {
      placement: placement,
      enableEventListeners: false,
      modifiers: {
        flip: {
          enabled: false
        },
        preventOverflow: {
          escapeWithReference: true
        },
        keepTogether: {
          enabled: true
        }
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.popper.destroy();
    this.popper = null;
  };

  _proto.handleClickOutside = function handleClickOutside() {
    if (this.state.isOpen) {
      this.setState({
        isOpen: false
      });
    }
  };

  _proto.toggleDropdown = function toggleDropdown() {
    var _this2 = this;

    this.setState(function (_ref) {
      var isOpen = _ref.isOpen;
      return {
        isOpen: !isOpen
      };
    }, function () {
      if (_this2.state.isOpen) {
        _this2.popper.enableEventListeners();

        _this2.popper.scheduleUpdate();
      } else {
        _this2.popper.disableEventListeners();
      }
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        children = _this$props.children,
        className = _this$props.className,
        id = _this$props.id,
        buttonProps = _this$props.buttonProps,
        ButtonOverride = _this$props.button;
    var isOpen = this.state.isOpen;
    return _react.default.createElement(Container, {
      className: className,
      "data-e2e": id
    }, ButtonOverride ? _react.default.createElement(ButtonOverride, {
      onClick: this.toggleDropdown,
      ref: this.button,
      isOpen: isOpen
    }) : _react.default.createElement(_Button.default, _extends({}, buttonProps, {
      type: "button",
      onClick: this.toggleDropdown,
      ref: this.button
    }), _react.default.createElement(FlexContainer, null, _react.default.createElement(TitleContainer, null, title), _react.default.createElement(DropdownIcon, {
      isOpen: isOpen
    }))), (0, _reactDom.createPortal)(_react.default.createElement(ItemsList, {
      "data-testid": "dropdown-items",
      className: "ignore-react-onclickoutside",
      visible: isOpen,
      ref: this.menu
    }, children), document.querySelector('body')));
  };

  return Dropdown;
}(_react.default.Component);

exports.UnwrappedDropdown = Dropdown;
Dropdown.displayName = 'Dropdown';
Dropdown.propTypes = {
  children: _propTypes.node.isRequired,
  title: _propTypes.string.isRequired,
  className: _propTypes.string,
  id: _propTypes.string,
  buttonProps: (0, _propTypes.shape)({}),
  // eslint-disable-next-line react/forbid-prop-types
  button: _propTypes.any,
  placement: _propTypes.string
};
Dropdown.defaultProps = {
  className: '',
  id: '',
  buttonProps: {},
  button: null,
  placement: 'bottom-start'
};

var _default = (0, _reactOnclickoutside.default)(Dropdown, {
  excludeScrollbar: true
});

exports.default = _default;